export const blockIconsTextformattingTableNew = (
	<span className='material-symbols-outlined'>table</span>
);
